import { Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { LanguagesActions } from './store/languages/languages.actions';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from './services/product.service';
import { ProductsActions } from './store/products/products.actions';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'SVET-front';

  constructor(
    private store: Store,
    private translateService: TranslateService,

  ) {
    this.store.dispatch(LanguagesActions.loadLanguages()),
      this.translateService.addLangs(['fr', 'en']);
    this.translateService.setDefaultLang('fr');
    this.translateService.use('fr');
   
  }
}
